var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFill75(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "221px",
    height: "6px",
    viewBox: "0 0 221 6",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "33C09F02-EE0C-4AC7-A834-1C022969AFC6") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "11-12-13-Subscribe/payment/subscriptions",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Chose-subscription-11_148-View-suggested-subscription_choosen",
    transform: "translate(-610.000000, -490.000000)",
    fill: "#EDE8DD"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Modal-view",
    transform: "translate(192.000000, 160.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-18",
    transform: "translate(40.000000, 131.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(332.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M254.395986,201.801805 C222.830057,201.211861 194.291062,201.301301 164.846168,201.142074 C142.124058,201.018657 100.129792,201.516648 73.8028454,199.659031 C60.4521762,198.716775 46.6617453,198.787915 46.4197998,199.853187 C46.390986,199.985245 46.362328,200.11659 46.3335143,200.248648 C46.1244484,201.163302 54.0528146,202.209206 64.5733518,203.051476 C96.8633842,205.638259 132.193543,204.922669 156.893285,204.870519 C193.862275,204.791458 235.602484,204.847872 263.978832,203.586792 C269.450312,203.344899 265.009529,201.999961 254.395986,201.801805",
    id: "Fill-75"
  }))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFill75);
export default __webpack_public_path__ + "static/media/fill-75.ea927f9131bb10e03ac8c025826e5322.svg";
export { ForwardRef as ReactComponent };